import { DomHelpers } from '../core/DomHelpers.js';
import '../locales/en.js';
import '../locales/ru.js';
import { ViewCmdType } from '../view/IViewWidget.js';
import { ViewWidgetHelper } from '../view/ViewWidgetHelper.js';
import { createPopper } from '@popperjs/core';
import { delegate, hideAll } from 'tippy.js';
import '../core/ImSys.js';

const responsiveAsideMaxWidth = 1079;
let responsiveAsideStateBound = false;
let mobileAsideExclusiveBound = false;
function isNewArticleEditorPage() {
    return document.body.classList.contains("new-article-editor");
}
function isMobileViewport() {
    if (typeof window.matchMedia === "function") {
        return window.matchMedia(`(max-width: ${responsiveAsideMaxWidth}px)`).matches;
    }
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    return viewportWidth <= responsiveAsideMaxWidth;
}
/**
 * Инициализация бокового меню: вешает обработчики и настраивает активные пункты.
 */
function initAsideMenu() {
    const rollup = document.querySelector(".aside-menu__rollup");
    if (rollup) {
        rollup.addEventListener("click", toggleMenu);
    }
    const themeSwitcher = document.querySelector(".theme-switcher");
    if (themeSwitcher) {
        themeSwitcher.addEventListener("click", () => document.body.classList.toggle("dark-theme"));
    }
    syncResponsiveAsideStates();
    bindResponsiveAsideState();
    bindMobileAsideExclusiveToggle();
}
function initAsideMenuState() {
    if (!isNewArticleEditorPage())
        return;
    const menu = document.querySelector(".aside-menu");
    if (!menu)
        return;
    menu.classList.toggle("aside-menu_short", isMobileViewport());
}
function initArticleAsideDetailedState() {
    const aside = document.querySelector(".article-aside-detailed");
    if (!aside)
        return;
    aside.classList.toggle("short", isMobileViewport());
}
function syncResponsiveAsideStates() {
    initAsideMenuState();
    initArticleAsideDetailedState();
    initMenu();
}
function bindResponsiveAsideState() {
    if (responsiveAsideStateBound)
        return;
    responsiveAsideStateBound = true;
    if (typeof window.matchMedia === "function") {
        const mediaQuery = window.matchMedia(`(max-width: ${responsiveAsideMaxWidth}px)`);
        if (typeof mediaQuery.addEventListener === "function") {
            mediaQuery.addEventListener("change", syncResponsiveAsideStates);
            return;
        }
        if (typeof mediaQuery.addListener === "function") {
            mediaQuery.addListener(syncResponsiveAsideStates);
            return;
        }
    }
    window.addEventListener("resize", syncResponsiveAsideStates);
}
function collapseOppositeMobileAside(openedAside) {
    if (!isNewArticleEditorPage() || !isMobileViewport())
        return;
    if (openedAside === "left") {
        document.querySelector(".article-aside-detailed")?.classList.add("short");
        return;
    }
    const menu = document.querySelector(".aside-menu");
    if (!menu)
        return;
    menu.classList.add("aside-menu_short");
    initMenu();
}
function openArticleAsideDetailedMobile() {
    if (!isNewArticleEditorPage() || !isMobileViewport())
        return;
    const articleAside = document.querySelector(".article-aside-detailed");
    if (!articleAside)
        return;
    articleAside.classList.remove("short");
    collapseOppositeMobileAside("right");
}
function bindMobileAsideExclusiveToggle() {
    if (mobileAsideExclusiveBound)
        return;
    mobileAsideExclusiveBound = true;
    document.addEventListener("click", (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target)
            return;
        if (target.closest(".btn-toggle-article-detailed")) {
            window.setTimeout(() => {
                const articleAside = document.querySelector(".article-aside-detailed");
                if (!articleAside || articleAside.classList.contains("short"))
                    return;
                collapseOppositeMobileAside("right");
            }, 0);
        }
        if (target.closest("[data-key='btOpenAsideEdit']")) {
            window.setTimeout(openArticleAsideDetailedMobile, 0);
        }
    });
}
/** Настройка кнопок подсписков и раскрытие активных элементов */
function initMenu() {
    const menu = document.querySelector(".aside-menu");
    if (!menu)
        return;
    const isShort = menu.classList.contains("aside-menu_short");
    menu.querySelectorAll(".btn-slider").forEach(btn => {
        // снимаем старые обработчики (клонированием)
        const clone = btn.cloneNode(true);
        btn.replaceWith(clone);
        if (!isShort) {
            clone.addEventListener("click", e => {
                e.preventDefault();
                toggleList(clone);
            });
        }
    });
    menu.querySelectorAll(".aside-menu__lvl-2").forEach(list => {
        if (list.querySelector("._cur")) {
            const prev = list.previousElementSibling;
            if (prev && !prev.classList.contains("btn-slider_active")) {
                prev.classList.add("btn-slider_active");
                list.style.display = "block";
            }
        }
    });
}
/**
 * Переключает состояние бокового меню (короткое/полное) и уведомляет imView через ImViewBridge.
 * От имени элемента с data-key="toggleButton" отправляется item-команда:
 *  - 'set-aside-collapsed'  при сворачивании
 *  - 'set-aside-normal'     при разворачивании
 */
function toggleMenu() {
    const menu = document.querySelector(".aside-menu");
    if (!menu)
        return;
    // Переключаем класс
    menu.classList.toggle("aside-menu_short");
    const collapsed = menu.classList.contains("aside-menu_short");
    // Элемент, от имени которого шлём команду
    const sender = menu.querySelector("[data-key='toggleButton']") ??
        menu;
    // Отправляем item-команду в совместимый jQuery imView через мост
    ViewWidgetHelper.ExecCmd(sender, {
        cmdType: ViewCmdType.itemcmd,
        cmd: collapsed ? "set-aside-collapsed" : "set-aside-normal"
        // options / onSuccess / onError можно добавить при необходимости
    });
    // Переинициализируем обработчики подменю согласно новому состоянию
    initMenu();
    if (!collapsed) {
        collapseOppositeMobileAside("left");
    }
}
/** Переключает раскрытие конкретного подсписка */
function toggleList(el) {
    const next = el.nextElementSibling;
    if (!next)
        return;
    if (el.classList.contains("btn-slider_active")) {
        el.classList.remove("btn-slider_active");
        DomHelpers.slideUp(next);
    }
    else {
        el.classList.add("btn-slider_active");
        DomHelpers.slideDown(next);
    }
}
/** Отрисовка svg спрайта на тестовой странице */
function renderSvgSprite() {
    if (document.body.classList.contains('testpage')) {
        fetch('/src/vs/svg/sprite/sprite.svg')
            .then(r => r.text())
            .then(text => {
            const svgInline = document.body.querySelector('#svg-inline');
            if (!svgInline)
                return;
            svgInline.insertAdjacentHTML("beforeend", text);
            const symbols = svgInline.querySelectorAll('symbol');
            const svgContainer = document.body.querySelector('#svg-container');
            if (!svgContainer)
                return;
            symbols.forEach((elem) => {
                const name = elem.getAttribute('id');
                if (!name)
                    return;
                // функция-хелпер для строки → DOM-элемент
                const createFragment = (html) => {
                    const tpl = document.createElement("template");
                    tpl.innerHTML = html.trim();
                    return tpl.content.firstElementChild;
                };
                if (name.includes('_')) {
                    const group = name.slice(0, name.indexOf('_'));
                    let groupElem = document.body.querySelector(`.${group} .container`);
                    if (groupElem) {
                        groupElem.appendChild(createFragment(`
                            <div>
                              <svg class="svg-icon">
                                <use href="/src/vs/svg/sprite/sprite.svg#${name}" />
                              </svg>
                              <p>${name}</p>
                            </div>
                        `));
                    }
                    else {
                        svgContainer.prepend(createFragment(`
                            <section class="${group}">
                                <h3>${group}</h3>
                                <div class="container">
                                    <div>
                                        <svg class="svg-icon">
                                            <use href="/src/vs/svg/sprite/sprite.svg#${name}" />
                                        </svg>
                                        <p>${name}</p>
                                    </div>
                                </div>
                            </section>
                        `));
                    }
                }
                else {
                    const containerNotSorted = svgContainer.querySelector('.not-sorted .container');
                    if (containerNotSorted) {
                        containerNotSorted.appendChild(createFragment(`
                            <div>
                                <svg class="svg-icon">
                                    <use href="/src/vs/svg/sprite/sprite.svg#${name}" />
                                </svg>
                                <p>${name}</p>
                            </div>
                        `));
                    }
                }
            });
        })
            .catch(console.error);
    }
}
/** Инициализация тултипа Tippy */
function initTippy() {
    delegate(document.body, {
        // Добавлено [data-tippy-content] из за нежелательных последствий использования title 
        // на точках карты в случае сбоя появлялись стандартные fallback тексты из title  | 2026-03 -13
        target: `[title],[data-tippy-content]`,
        delay: [300, 600],
        placement: 'top-start',
        animation: 'fade',
        onShow(instance) {
            //Если title пустой - не показываем
            if (!instance.props.content) {
                return false;
            }
            const ref = instance.reference;
            const theme = ref.dataset.tippyTheme;
            if (theme) {
                instance.setProps({ theme }); // применится только где задан data-tippy-theme
            }
            hideAll({ exclude: instance });
        },
        content(reference) {
            const contentFromData = reference.getAttribute('data-tippy-content') || '';
            if (contentFromData) {
                return contentFromData;
            }
            const text = reference.getAttribute('title') || '';
            if (text) {
                reference.setAttribute('data-tippy-content', text);
                reference.removeAttribute('title');
            }
            return text;
        }
    });
}
/**
 * Делегированная инициализация подсказок на кнопках .btn-icon-tip
 */
function initDelegatedIconTips() {
    let currentPopper = null;
    let currentTip = null;
    // Общий обработчик для контейнера (document или конкретного блока)
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const btn = target?.closest('.btn-icon-tip');
        // Клик по кнопке подсказки
        if (btn) {
            const wrapper = btn.closest('.tip-wrapper');
            if (!wrapper)
                return;
            const tip = wrapper.querySelector('.tip-text');
            if (!tip)
                return;
            const isHover = btn.classList.contains('onhover');
            // Для кнопок "по клику" — переключение видимости
            if (!isHover) {
                const isVisible = tip.style.display === 'block';
                // Скрываем предыдущий, если открыт другой
                if (currentTip && currentTip !== tip) {
                    currentTip.style.display = 'none';
                    currentPopper?.destroy();
                    currentPopper = null;
                    currentTip = null;
                }
                if (isVisible) {
                    tip.style.display = 'none';
                    currentPopper?.destroy();
                    currentPopper = null;
                    currentTip = null;
                }
                else {
                    tip.style.display = 'block';
                    currentPopper = createPopper(btn, tip, {
                        placement: 'top-start',
                        modifiers: [
                            { name: 'offset', options: { offset: [16, 16] } },
                            { name: 'preventOverflow', options: { boundary: 'viewport' } }
                        ]
                    });
                    currentTip = tip;
                }
            }
        }
        else {
            // Клик вне подсказки — скрываем текущую
            if (currentTip) {
                currentTip.style.display = 'none';
                currentPopper?.destroy();
                currentPopper = null;
                currentTip = null;
            }
        }
    });
    // Делегат для hover-подсказок
    document.body.addEventListener('pointerover', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target)
            return;
        const btn = target.closest('.btn-icon-tip.onhover');
        if (!btn)
            return;
        const wrapper = btn.closest('.tip-wrapper');
        const tip = wrapper?.querySelector('.tip-text');
        if (!tip)
            return;
        tip.style.display = 'block';
        currentPopper?.destroy();
        currentPopper = createPopper(btn, tip, {
            placement: 'top-start',
            modifiers: [
                { name: 'offset', options: { offset: [16, 16] } },
                { name: 'preventOverflow', options: { boundary: 'viewport' } }
            ]
        });
    }, true);
    document.body.addEventListener('pointerout', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target)
            return;
        const btn = target.closest('.btn-icon-tip.onhover');
        if (!btn)
            return;
        const toEl = event.relatedTarget instanceof Element
            ? event.relatedTarget
            : null;
        // если курсор ушёл внутрь той же кнопки / тултипа — не закрываем
        if (toEl && btn.contains(toEl))
            return;
        const wrapper = btn.closest('.tip-wrapper');
        const tip = wrapper?.querySelector('.tip-text');
        if (!tip)
            return;
        tip.style.display = 'none';
        currentPopper?.destroy();
        currentPopper = null;
    }, true);
}
/** Инициализация компонента уведомлений (справа вверху) */
function initNotification() {
    const notif = document.querySelector('im-notification');
    if (!notif) {
        const notification = document.createElement('im-notification');
        document.body.appendChild(notification);
    }
}
/** Перезагрузка стилей без перезагрузки страницы через ctrl + q */
function initReloadCss() {
    document.querySelectorAll('link[rel="stylesheet"][href^="/src/"]').forEach(link => {
        const cssHref = link.getAttribute("href");
        const handler = (e) => {
            if (e.ctrlKey && e.code === "KeyQ") {
                link.href = `${cssHref}?id=${new Date().getMilliseconds()}`;
            }
        };
        // снимаем старый обработчик, если был
        document.removeEventListener("keyup", handler);
        document.addEventListener("keyup", handler);
    });
}

export { initArticleAsideDetailedState, initAsideMenu, initAsideMenuState, initDelegatedIconTips, initMenu, initNotification, initReloadCss, initTippy, renderSvgSprite, syncResponsiveAsideStates, toggleList, toggleMenu };
